<template>
  <v-dialog v-model="loading" fullscreen transition="fade-transition">
    <v-container fluid fill-height style="background-color: rgba(46, 49, 49, 0.2);">
      <v-layout justify-center align-center>
        <v-progress-circular size="70" indeterminate color="primary"></v-progress-circular>
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    active(open) {
      open;
      this.loading = open == null ? !this.loading : open;
    },
  },
};
</script>

